// Evita quebra no browser ao ler process.env dentro do SDK do Sentry (getVercelEnv)
// Em ambientes sem polyfill de process/env no cliente, garantimos um objeto vazio.
;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"f773057b57b3019946118666885ec192b6cbec57"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";if (typeof window !== "undefined") {
  const g: any = globalThis as any;
  g.process = g.process || {};
  g.process.env = g.process.env || {};
  // Valor opcional para evitar acessos indefinidos; não altera env real do build
  if (g.process.env.NEXT_PUBLIC_VERCEL_ENV === undefined) {
    g.process.env.NEXT_PUBLIC_VERCEL_ENV = "";
  }

  // Import dinâmico para só carregar o SDK no cliente após o guard acima
  import("@sentry/nextjs")
    .then((Sentry) => {
      Sentry.init({
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
        environment:
          process.env.NEXT_PUBLIC_SENTRY_ENV || process.env.NODE_ENV || "development",
        // Ajuste amostragem de tracing conforme necessidade
        tracesSampleRate: 0.1,
      });
    })
    .catch(() => {
      // Silencia falhas de carregamento do SDK no dev para não quebrar a aplicação
    });
}
